import { render, staticRenderFns } from "./PageAdminTenants.vue?vue&type=template&id=0c5d7b3c"
import script from "./PageAdminTenants.vue?vue&type=script&lang=js"
export * from "./PageAdminTenants.vue?vue&type=script&lang=js"
import style0 from "./PageAdminTenants.vue?vue&type=style&index=0&id=0c5d7b3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports